import React from 'react';
import { ArrowRight } from 'lucide-react';
import { whyPureBuild } from '../data/site';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function WhyPureBuild() {
  return <section id="why" className="relative w-full overflow-hidden bg-navy-900 py-24 lg:py-32" data-id="element-397" data-mp="3oa7469q5mhiw">
      <div className="grid-lines absolute inset-0" aria-hidden="true" data-id="element-398" data-mp="3jb3zwri00fbz" />

      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8" data-id="element-399" data-mp="ks5esmon8o4z">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-400" data-mp="kqchhxzx7g9n">
          <Reveal data-id="element-401" data-mp="fu40sg62rf0d">
            <SectionHeading label="The Difference" tone="dark" title="Why Pure Build" description="Six reasons homeowners hand us the keys to their biggest investment." data-id="element-402" data-mp="frhndzwi65a8" />
          </Reveal>
          <Reveal delay={0.1} data-id="element-403" data-mp="2vl9ngb1lcss9">
            <a href="#contact" className="group inline-flex items-center gap-3 border-b-2 border-white/30 pb-2 font-heading text-[13px] font-bold uppercase tracking-[0.16em] text-white transition hover:border-brand-500 hover:text-brand-400" data-id="element-404" data-mp="2vi3xyup1vow0">
              Talk to our team
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" aria-hidden="true" data-id="element-405" data-mp="3ivv2bhhj4hqm" />
            </a>
          </Reveal>
        </div>

        <ul className="mt-16 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-406" data-mp="3nx0xrn2kqj3u">
          {whyPureBuild.map((item, i) => <Reveal as="li" key={item.index} delay={i % 3 * 0.08} className="bg-navy-900" data-id="element-407" data-mp="3euhz7f5tmsne" data-mpi={i}>
              <div className="group h-full p-8 transition duration-500 hover:bg-navy-800 lg:p-10" data-id="element-408" data-mp="3064xs2nyshli">
                <span className="font-mono text-xs font-semibold tracking-[0.24em] text-brand-500" data-id="element-409" data-mp="353nam453rgys">{item.index}</span>
                <h3 className="mt-6 font-heading text-xl font-extrabold uppercase tracking-tight text-white" data-id="element-410" data-mp="2r5yo6rve01rm">
                  {item.title}
                </h3>
                <span className="mt-4 block h-px w-10 bg-brand-500 transition-all duration-500 group-hover:w-20" aria-hidden="true" data-id="element-411" data-mp="11n9xrjg475sy" />
                <p className="mt-5 text-sm leading-relaxed text-white/55" data-id="element-412" data-mp="rxqc6610oxue">{item.text}</p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}